exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.image{width:100px;height:100px;background-size:cover;cursor:pointer;margin:5px;border-radius:3px;border:1px solid #d3d3d3;-o-object-fit:contain;object-fit:contain\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build@2/frontend/common-v2/components/Timelineblock.vue"],"names":[],"mappings":";AACA,OAAO,YAAY,aAAa,sBAAsB,eAAe,WAAW,kBAAkB,yBAAyB,sBAAsB,kBAAkB;CAClK","file":"Timelineblock.vue","sourcesContent":["\n.image{width:100px;height:100px;background-size:cover;cursor:pointer;margin:5px;border-radius:3px;border:1px solid #d3d3d3;-o-object-fit:contain;object-fit:contain\n}"],"sourceRoot":""}]);

// exports
